// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import DefaultProfile from '../_raw/ui/icon_default_profile.svg';

export default withIconProps(DefaultProfile, { shouldSetDefaultSize: false });
